export class CallUpdateModel
{
    billable: boolean;
    notable: boolean;
    important:  boolean;
    comment: string;
}